function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 16l2.8-2.1 2.75 2.1-1.05-3.4 2.8-2.2h-3.4L12 7l-1.1 3.4H7.5l2.75 2.2L9.2 16zM4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 18v-3.375c0-.183.058-.342.175-.475a.76.76 0 01.45-.25c.4-.133.73-.375.987-.725A1.93 1.93 0 004 12c0-.433-.13-.825-.388-1.175a1.983 1.983 0 00-.987-.725.76.76 0 01-.45-.25A.698.698 0 012 9.375V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 014 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v3.375a.697.697 0 01-.175.475.76.76 0 01-.45.25c-.4.133-.73.375-.988.725S20 11.567 20 12c0 .433.13.825.387 1.175.259.35.588.592.988.725a.76.76 0 01.45.25.697.697 0 01.175.475V18c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 20H4zm0-2h16v-2.55a4.1 4.1 0 01-1.462-1.462A3.846 3.846 0 0118 12c0-.717.18-1.38.538-1.988A4.099 4.099 0 0120 8.55V6H4v2.55a4.1 4.1 0 011.463 1.462C5.82 10.621 6 11.284 6 12c0 .717-.18 1.38-.537 1.988A4.1 4.1 0 014 15.45V18z"
  }));
};
const SvgActivity = styled(BaseComponent).withConfig({
  displayName: "Activity__SvgActivity",
  componentId: "sc-1pw94d0-0"
})(["outline:none;"]);
SvgActivity.isIcon = true;
SvgActivity.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgActivity;